import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import { AppointmentOptionsModalKeys } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/variants/_components/appointment-options/appointment-options-button.component';
import { DependentForm } from '@/app/(main)/(pages)/(auth)/dependentes/_components/dependent-form.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { ModalCloseButton } from '@/components/ui/modal-close-button/modal-close-button.component';

export function SelectPatientCreate() {
  const { handleJump, onClose } = useProgressiveModal<AppointmentOptionsModalKeys>();

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-start justify-between gap-2">
        <Typography variant={TypographyVariant.MODAL_TITLE}>
          Criar dependente
        </Typography>
        <ModalCloseButton onClick={onClose} className="shrink-0" label="Fechar modal" />
      </div>
      <DependentForm
        onSuccessCallback={() => handleJump({ key: AppointmentOptionsModalKeys.CHANGE_PATIENT_LIST })}
        onBack={() => handleJump({ key: AppointmentOptionsModalKeys.CHANGE_PATIENT_LIST })}
      />
    </div>
  );
}
